// https://www.algolia.com/doc/ui-libraries/autocomplete/core-concepts/sources/
import React from 'react'
import fetchLocationAutocomplete from '../../../utils/search/fetchLocationAutocomplete'
import AutoCompleteResultItem from '../AutoCompleteResultItem'
import AutocompleteListHeader from '../AutocompleteListHeader'
import { isMobile } from 'react-device-detect'
import qs from 'qs'
import { isNonEmptyString } from '../../../utils/checks'

const FOOTER_ITEM = {
  type: 'footer',
  _highlightResult: {
    formattedAddress: {
      value: 'Browse All Locations'
    }
  },
  slug: `browse`
}

const DESKTOP_MIN_LOCATIONS_TO_RETURN = 4
const MOBILE_MIN_LOCATIONS_TO_RETURN = 3

const MIN_LOCATIONS_TO_RETURN = isMobile
  ? MOBILE_MIN_LOCATIONS_TO_RETURN
  : DESKTOP_MIN_LOCATIONS_TO_RETURN

const MAX_LOCATIONS_TO_RETURN = 10

const getLocationsResultsLimit = (state) =>
  state?.context?.increaseLocationsLimit
    ? MAX_LOCATIONS_TO_RETURN
    : MIN_LOCATIONS_TO_RETURN

export const AUTOCOMPLETE_SOURCE_ID = 'locationApiResults'

const locationAutocompleteSource = ({ onSelect }) => {
  return {
    sourceId: AUTOCOMPLETE_SOURCE_ID,
    getItemInputValue: ({ item }) => item.query,
    getItems: async ({ query, state }) => {
      if (isNonEmptyString(query)) {
        const results = await fetchLocationAutocomplete({
          query,
          limit: getLocationsResultsLimit(state)
        })

        if (results.length === 0) {
          return results
        }

        const modifiedResults = results.map((result) => ({
          ...result,
          type: 'location',
          slug: `browse/?${qs.stringify({
            refinementList: { locations: result.title }
          })}`
        }))
        // this footer item needs to be navigable by keyboard
        // so we need to insert it on the list of results
        modifiedResults.push(FOOTER_ITEM)
        return modifiedResults
      }
      return []
    },
    templates: {
      header() {
        return <AutocompleteListHeader title="Locations" />
      },
      item({ item }) {
        return (
          <AutoCompleteResultItem
            result={item}
            className="h-[56px]"
          />
        )
      }
    },
    onSelect
  }
}

export default locationAutocompleteSource
